module.exports = "<span class=\"title\">{{config.title}}</span>\r\n<div class=\"panel-buttons\">\r\n    <fw-bar-button *ngFor=\"let button of config.buttonDefinition\" [title]=\"button.description\" [isSmall]=\"button.isSmall\" [clickEventType]=\"button.clickEventType\" (buttonClick)=\"btnClicked($event)\"></fw-bar-button>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./Scripts/fw/pages/page-subheader-bar.component.html
// module id = 2152
// module chunks = 1